export const DEVICE_PERMISSION_NAME = {
	CAMERA: "camera",
};

export const CAMERA_PERMISSION_STATE = {
	GRANTED: "granted",
	DENIED: "denied",
	PROMPT: "prompt",
};

export const UNREAD_MESSAGE_UPDATED_ACTION = {
	reset: "reset",
	update: "update",
};

export const TABLE_DEFAULT_PAGE_SIZE = 20;

export const SEARCH_DATE_TIME_MIN = ["friendAddedDateMin", "lastVisitMin", "memberSinceMin"];
export const SEARCH_DATE_TIME_MAX = ["friendAddedDateMax", "lastVisitMax", "memberSinceMax"];

export const DEFAULT_TEXT_NONE_DISPLAY = "ー";

export const AUDIENCE_PARTICIPATION_STATUS = {
	PARTICIPATE: "participate",
	RESERVE: "reserve",
	CANCEL: "cancel",
};

export const AUDIENCE_PARTICIPATION_STATUS_LABEL = {
	[AUDIENCE_PARTICIPATION_STATUS.PARTICIPATE]: "参加",
	[AUDIENCE_PARTICIPATION_STATUS.RESERVE]: "予約",
	[AUDIENCE_PARTICIPATION_STATUS.CANCEL]: "キャンセル",
};

export const LINE_CHAT_CONTACT_LINK = import.meta.env
	.VITE_APP_CHAT_LINE_CONTACT_LINK;

export const COMPARE_TYPES = {
	IS_BEFORE: "is-before",
	IS_SAME: "is-same",
	IS_AFTER: "is-after",
	IS_SAME_OR_BEFORE: "is-same-or-before",
	IS_SAME_OR_AFTER: "is-same-or-after",
	IS_NOT_SAME: "is-not-same",
};
